import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from './alertMessageSlice';

import TopicService from '../services/topic.service';
import {
  channelManipulation,
  channelReviewManipulation,
} from '../utils/channelCreation';

export const topicPreview = createAsyncThunk(
  'topicPreview',
  async (body, thunkAPI) => {
    try {
      const topic_post_data = {
        topic_title: body?.title,
        description: body?.description || '',
        languages: body?.languages || null,
        time_frame: body?.timeFrame || 'last 1 month',
        keywords_string: body?.keywords || body?.keywords_string || '',
        exclusions_string: body?.exclusions || '',
        exclusions_noise: {
          select_all: false,
          sweep_stakes: false,
          sales_listings: false,
          coupons: false,
          supplemental_income: false,
          cryptocurrency: false,
        },
        channel_name: body?.channels || [],
        location_origin: body?.location || null,
        location_origin_radius: body?.locationRadius || null,
        post_country: body?.postCountry || [],
        user_country: '',
        include_sensitive_content: body?.include_sensitive_content || false,
        only_posts_with_media: body?.only_posts_with_media || null,
        fetch_reposts: body?.fetch_reposts || null,
        only_posts_from_verified_users:
          body?.only_posts_from_verified_users || null,
        // keywords_string:,

        // ...(body?.channels === 'instagram' && {
        //   search_type: body?.search_type || '',

        // }),
        ...(body?.channels === 'instagram'
          ? {
              search_type: body?.search_type || null,
              user_name: body?.user_name || '',
              full_name: body?.full_name || '',
              verified: body?.verified || false,
              engagement: body?.engagement || 0,
              profile_pic_url: body?.profile_pic_url || '',
              // facebook_search_type: body?.search_type || '',
            }
          : // && body?.search_type == 'pages'
          body?.channels == 'youtube' && body?.youtube_search_type == 'video'
          ? {
              youtube_search_type: body?.youtube_search_type || null,
            }
          : // && body?.search_type == 'pages'
          body?.channels == "youtube" && body?.youtube_search_type == "page" ?
          {
            youtube_search_type: body?.youtube_search_type || null,
            user_name: body?.user_name || '',
            profile_pic_url: body?.profile_pic_url || '',
            description: body?.description || '',
            followers: body?.subscriber_count || '',
            page_description: body?.page_description || '',
          }
          :
          body?.channels == 'facebook' && body?.search_type == 'pages'
          ? {
              // search_type: body?.search_type || '',
              user_name: body?.user_name || '',
              full_name: body?.full_name || '',
              verified: body?.verified || false,
              engagement: body?.engagement || 0,
              profile_pic_url: body?.profile_pic_url || '',
              facebook_search_type: body?.search_type || null,
              page_description: body?.page_description || '',
              category: body?.category || '',
              followers: body?.followers || '',
            }
          : body?.channels == 'facebook' && {
              // search_type: body?.search_type || '',
              user_name: body?.user_name || '',
              full_name: body?.full_name || '',
              verified: body?.verified || false,
              engagement: body?.engagement || 0,
              profile_pic_url: body?.profile_pic_url || '',
              facebook_search_type: body?.search_type || null,
            }),
      };

      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const fetch_uuid_for_topicPreview =
        await TopicService.fetch_uuid_for_topicPreview(
          topic_post_data,
          brandUser?.tenant_id,
          brandUser?.user_details.user_id
        );
      if (
        fetch_uuid_for_topicPreview === 'Chatter title should be unique' ||
        fetch_uuid_for_topicPreview === 'Topic title should be unique' ||
        fetch_uuid_for_topicPreview ===
          'A chatter with the same name is already in progress. Please choose a different name' ||
        fetch_uuid_for_topicPreview ===
          'A topic with the same name is already in progress. Please choose a different name'
      ) {
        thunkAPI?.dispatch(setMessage(fetch_uuid_for_topicPreview));
      }
      sessionStorage.setItem(
        'fetch_uuid_for_topicPreview',
        JSON.stringify(fetch_uuid_for_topicPreview)
      );
      sessionStorage.setItem('topicPreviewLoading', 'true');

      let actualResponse;
      let counter = 0;
      const refreshPreviewData = async () => {
        // if (counter === 30) {
        //   sessionStorage.removeItem('fetch_uuid_for_topicPreview');
        //   sessionStorage.removeItem('topicPreviewLoading');
        //   return { data: 'No data' };
        // }
        // counter += 1;
        actualResponse = await TopicService.topicPreview(
          fetch_uuid_for_topicPreview?.preview_uuid,
          // counter,
          brandUser?.tenant_id,
          brandUser?.user_details.user_id
        );
        if (typeof actualResponse === 'object') {
          sessionStorage.removeItem('fetch_uuid_for_topicPreview');
          sessionStorage.removeItem('topicPreviewLoading');
          actualResponse.preview_uuid =
            fetch_uuid_for_topicPreview?.preview_uuid;
          actualResponse.inputData = topic_post_data;
          // actualResponse.inputData.preview_uuid =
          // fetch_uuid_for_topicPreview?.preview_uuid;
          thunkAPI.dispatch(resetFlagFunc(false));
          thunkAPI.dispatch(
            setMessage('Topic Preview has been Successfully Created')
          );

          return actualResponse;
        } else {
          let status = actualResponse.split(' ');

          status.shift();

          // Join the remaining words back into a string
          let resultString = status.join(' ');

          if (resultString && resultString == 'still in progress') {
            await new Promise((resolve) => setTimeout(resolve, 8000));
            return refreshPreviewData();
          } else if (resultString && resultString == 'has failed') {
            sessionStorage.removeItem('fetch_uuid_for_topicPreview');
            sessionStorage.removeItem('topicPreviewLoading');

            return { data: 'Has Failed' };
          }
        }
      };
      return await refreshPreviewData();
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  }
);
export const editTopicPreview = createAsyncThunk(
  'editTopicPreview',
  async (body, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));

      const topic_post_data = {
        topic_title: body?.title,
        description: body?.description || '',
        languages: body?.languages || null,
        time_frame: body?.timeFrame || 'last 1 month',
        keywords_string: body?.keywords || '',
        exclusions_string: body?.exclusions || '',
        channel_name: body?.channels || 'twitter',
        location_origin: body?.location || null,
        location_origin_radius: body?.locationRadius || null,
        only_posts_with_media: body?.only_posts_with_media || null,
        fetch_reposts: body?.fetch_reposts || null,
        only_posts_from_verified_users: body?.only_posts_from_verified_users || null,
      };

      const preview_uuid = body?.preview_uuid;

      // Call PATCH edit endpoint
      await TopicService.editTopicPreview(
        topic_post_data,
        brandUser?.tenant_id,
        brandUser?.user_details.user_id,
        preview_uuid
      );

      // Poll same as topicPreview
      let actualResponse;
      const refreshPreviewData = async () => {
        actualResponse = await TopicService.topicPreview(
          preview_uuid,
          brandUser?.tenant_id,
          brandUser?.user_details.user_id
        );
        if (typeof actualResponse === 'object') {
          actualResponse.preview_uuid = preview_uuid;
          actualResponse.inputData = topic_post_data;

          actualResponse.keywords_string = topic_post_data.keywords_string;
          actualResponse.title = topic_post_data.topic_title;
          actualResponse.description = topic_post_data.description;
          actualResponse.languages = topic_post_data.languages;
          actualResponse.channel = topic_post_data.channel_name;
          
          thunkAPI.dispatch(resetFlagFunc(false));
          thunkAPI.dispatch(setMessage('Topic Preview has been Successfully Updated'));
          return actualResponse;
        } else {
          let status = actualResponse.split(' ');
          status.shift();
          let resultString = status.join(' ');
          if (resultString === 'still in progress') {
            await new Promise((resolve) => setTimeout(resolve, 8000));
            return refreshPreviewData();
          } else if (resultString === 'has failed') {
            return { data: 'Has Failed' };
          }
        }
      };
      return await refreshPreviewData();

    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getCommentsListPreview = createAsyncThunk(
  'fetch_Comments_Details_preview',
  async ({ channel, value, job_id, filterPayload }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const body = {
        channel: channel,

        post_url: value,
        ...filterPayload,
      };
      // { query: value, search_type: searchType };
      const data = await TopicService.fetch_Comments_Details_preview(
        body,
        brandUser?.tenant_id,
        job_id
      );
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getCommentsList = createAsyncThunk(
  'fetch_Comments_Details',
  async ({ filterPayload, channel, value, job_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const body = {
        channel: channel,
        post_url: value,
        ...filterPayload,
      };
      // { query: value, search_type: searchType };
      const data = await TopicService.fetch_Comments_Details(
        body,
        brandUser?.tenant_id,
        job_id
      );
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getFbSearchList = createAsyncThunk(
  'fetch_FB_Search_Details',
  async ({ searchType, value }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const body = { query: value, search_type: searchType };
      // { query: value, search_type: searchType };
      const data = await TopicService.fetch_FB_Search_Details(
        body,
        brandUser?.tenant_id,
        brandUser?.user_details.user_id
      );
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getYouTubeSearchList = createAsyncThunk(
  'fetch_YouTube_Search_Details',
  async ({ searchType, value }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const body = { query: value };
      // { query: value, search_type: searchType };
      const data = await TopicService.fetch_YouTube_Search_Details(
        body,
        brandUser?.tenant_id,
        brandUser?.user_details.user_id
      );
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString() ||
        'Result Not Found';
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getinstaSearchList = createAsyncThunk(
  'productDetailList',
  async ({ searchType, value,account_search_type }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const body = { query: value, search_type: searchType,account_search_type:account_search_type };

      const data = await TopicService.fetch_Insta_Search_Details(
        body,
        brandUser?.tenant_id,
        brandUser?.user_details.user_id
      );
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const reviewsForTopic = createAsyncThunk(
  'reviewsForTopic',
  async (preview_uuid, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TopicService.reviewsForTopic(
        brandUser?.tenant_id,
        brandUser?.user_details.user_id,
        preview_uuid
      );
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const reviewsFilterTopic = createAsyncThunk(
  'reviewsFilterTopic',
  async ({ filterPayload, job_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TopicService.reviewsFilterTopic(
        brandUser?.tenant_id,
        job_id,
        filterPayload
      );
      return { data };
    } catch (error) {
      const message =
        (error?.response &&
          error?.response?.data &&
          error?.response?.data?.detail?.[0]?.msg) ||
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const reviewsFilterTopicPreview = createAsyncThunk(
  'reviewsFilterTopicPreview',
  async ({ filterPayload, preview_uuid }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TopicService.reviewsFilterTopicPreview(
        brandUser?.tenant_id,
        preview_uuid,
        filterPayload
      );
      return { data };
    } catch (error) {
      const message =
        (error?.response &&
          error?.response?.data &&
          error?.response?.data?.detail?.[0]?.msg) ||
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const reviewsForCreatedTopic = createAsyncThunk(
  'reviewsForCreatedTopic',
  async (job_id, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TopicService.reviewsForCreatedTopic(
        brandUser?.tenant_id,
        job_id
      );
      let dataObj = channelReviewManipulation(data);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const reviewsForSingleComment = createAsyncThunk(
  'reviewsForSingleComment',
  async (apiVal, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TopicService.reviewsForSingleComment(
        apiVal?.tenant_id,
        apiVal?.job_id,
        apiVal?.post_id
      );

      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const reviewsForSinglePost = createAsyncThunk(
  'reviewsForSinglePost',
  async (apiVal, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TopicService.reviewsForSinglePost(
        apiVal?.tenant_id,
        apiVal?.job_id,
        apiVal?.post_id
      );

      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const renameTitleForTopic = createAsyncThunk(
  'renameTitleForTopic',
  async (apiVal, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      
      const data = await TopicService.RenameTitleForTopic(
        apiVal?.topic_title,
        brandUser?.tenant_id,
        apiVal?.job_id
      );
      thunkAPI.dispatch(activeTopicList());

      return { data };
    } catch (error) {
      console.log(error,"error");
      
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || (error.response.data.detail || error.response.data.message))) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const reviewsForDownload = createAsyncThunk(
  'reviewsForDownload',
  async (apiVal, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TopicService.reviewsForDownload(
        brandUser?.tenant_id,
        apiVal?.job_id,
        apiVal?.email_id
      );
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const activeTopicList = createAsyncThunk(
  'activeTopicList',
  async (_, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TopicService.activeTopicList(
        brandUser?.tenant_id,
        brandUser?.user_details.user_id
      );
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const fetchCreatedTopic = createAsyncThunk(
  'fetchCreatedTopic',
  async (job_id, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TopicService.fetchCreatedTopic(
        brandUser?.tenant_id,
        job_id
      );

      // const dataObj = channelManipulation(data);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.detail?.[0]?.msg) ||
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createNewTopic = createAsyncThunk(
  'createNewTopic',
  async (inputData, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TopicService.createNewTopic(
        brandUser?.tenant_id,
        brandUser?.user_details.user_id,
        inputData
      );

      thunkAPI.dispatch(setMessage('Topic is successfully created.'));
      return { data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.detail) ||
        (error.response &&
          error.response.data &&
          error.response.data.detail?.[0]?.msg) ||
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
                    
      thunkAPI.dispatch(setMessage({ message: message, type: 'rejected' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const TopicHibernate = createAsyncThunk(
  'TopicHibernate',
  async (jobId, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const response = await TopicService.TopicHibernate(
        brandUser?.tenant_id,
        brandUser?.user_details.user_id,
        jobId
      );
      thunkAPI.dispatch(setMessage('Topic hibernated successfully.'));
      return { response };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error?.response?.data?.detail) ||
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const TopicDelete = createAsyncThunk(
  'TopicDelete',
  async (jobId, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const response = await TopicService.TopicDelete(
        brandUser?.tenant_id,
        brandUser?.user_details.user_id,
        jobId
      );
      thunkAPI.dispatch(setMessage('Topic deleted successfully.'));
      return { response };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const TopicActive = createAsyncThunk(
  'TopicActive',
  async (jobId, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const response = await TopicService.TopicActive(
        brandUser?.tenant_id,
        brandUser?.user_details.user_id,
        jobId
      );

      thunkAPI.dispatch(setMessage('Topic activated successfully.'));
      return { response };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error?.response?.data?.detail) ||
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const FilterReportBasedOnDates = createAsyncThunk(
  'FilterReportBasedOnDates',
  async ({ startDate, endDate, job_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const response = await TopicService.GetReportBasedOnDate(
        startDate,
        endDate,
        brandUser?.tenant_id,
        job_id
      );
      // let resObj = channelManipulation(response)
      return {
        response: response,
        // reviews: response?.reviews
      };
    } catch (error) {
      const message =
        (error?.response &&
          error?.response?.data &&
          error?.response?.data.detail?.[0]?.msg) ||
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const DetailedInsightsData = createAsyncThunk(
  'DetailedInsightsData',
  async (
    { preview_uuid, job_id, insight_date, insight_type, filter_key },
    thunkAPI
  ) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const response = await TopicService.DetailedInsights(
        preview_uuid,
        job_id,
        insight_date,
        insight_type,
        brandUser?.tenant_id,
        filter_key
      );
      return {
        response: response,
      };
    } catch (error) {
      const message =
        (error?.response &&
          error?.response?.data &&
          error?.response?.data.detail?.[0]?.msg) ||
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const QueryPromptApi = createAsyncThunk(
  'QueryPromptApi',
  async ({ prompt, channel_name }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const response = await TopicService.GetQueryPromptData(
        prompt,
        channel_name
      );
      return { response };
    } catch (error) {

      const message =
        (error?.response &&
          error?.response?.data &&
          (error?.response?.data?.detail ||
            error?.response?.data?.detail?.[0]?.msg)) ||
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const topicAIPreview = createAsyncThunk(
  'topicAIPreview',
  async (body, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const fetch_uuid_for_topicPreview = await TopicService.PreviewAiData(
        body
      );
      if (
        fetch_uuid_for_topicPreview === 'Chatter title should be unique' ||
        fetch_uuid_for_topicPreview === 'Topic title should be unique'
      ) {
        thunkAPI.dispatch(setMessage(fetch_uuid_for_topicPreview));
        return;
      }
      sessionStorage.setItem(
        'fetch_uuid_for_topicPreview',
        JSON.stringify(fetch_uuid_for_topicPreview)
      );
      sessionStorage.setItem('topicPreviewLoading', 'true');

      const topic_post_data = {
        search_type: body?.search_type || null,
        topic_title: body?.title || '',
        description: body?.description || '',
        keywords_string: body?.keywords_string || '',
        channel_name: body?.channel_name || [],
        is_ai: true,
        prompt: body?.prompt || '',
        draft: body?.draft || '',
        facebook_search_type: body?.facebook_search_type || null,
        ...(body?.channel_name === 'instagram' && {
          search_type: body?.search_type || null,
          user_name: body?.full_name || null,
          profile_pic_url: body?.profilepic_url || null,
          verified: body?.verified || null,
          posts_count: body?.posts_count || null,
          engagement:
            body?.channel_name == 'instagram' && body?.search_type == 'user'
              ? body?.followers_count
              : body?.search_type == 'hashtag'
              ? body?.posts_count
              : null,
          followers:
            body?.search_type == 'hashtag' && body?.channel_name == 'instagram'
              ? body?.followers_count
              : null,
        }),
        ...(body?.channel_name === 'facebook' && {
          facebook_search_type: 'post',
        }),
        ...(body?.channel_name === 'youtube' &&
          body?.youtube_search_type === 'video' && {
            youtube_search_type: 'video',
          }),

        ...(body?.channel_name === 'youtube' &&
          body?.youtube_search_type === 'page' && {
            youtube_search_type: 'page',
            followers: body?.followers_count || null,
            full_name: body?.name || body?.full_name || null,
            profile_pic_url: body?.profilepic_url || null,
            url: body?.url || '',
          }),
      };
      let actualResponse;
      let counter = 0;
      const refreshPreviewData = async () => {
        if (counter === 30) {
          sessionStorage.removeItem('fetch_uuid_for_topicPreview');
          sessionStorage.removeItem('topicPreviewLoading');
          return { data: 'No data' };
        }
        counter += 1;
        actualResponse = await TopicService.topicPreview(
          fetch_uuid_for_topicPreview?.preview_uuid,
          // counter,
          fetch_uuid_for_topicPreview?.tenant_id,
          fetch_uuid_for_topicPreview?.user_id
        );
        if (
          actualResponse != null &&
          actualResponse != undefined &&
          typeof actualResponse !== 'object'
        ) {
          const firstSpaceIndex = actualResponse?.indexOf(' ');
          const firstWord = actualResponse?.substring(0, firstSpaceIndex);
          const restOfString = actualResponse?.substring(firstSpaceIndex + 1);

          if (restOfString == 'still in progress') {
            await new Promise((resolve) => setTimeout(resolve, 12000));
            return refreshPreviewData();
          } else if (restOfString == 'has failed') {
            // thunkAPI.dispatch(setMessage(message));
            return { data: 'Has Failed' };
          }
        } else if (typeof actualResponse === 'object') {
          sessionStorage.removeItem('fetch_uuid_for_topicPreview');
          sessionStorage.removeItem('topicPreviewLoading');
          // actualResponse.preview_uuid =
          //   fetch_uuid_for_topicPreview?.preview_uuid;
          actualResponse.inputData = topic_post_data;
          // actualResponse.inputData.preview_uuid =
          // fetch_uuid_for_topicPreview?.preview_uuid;

          thunkAPI.dispatch(resetFlagFunc(false));
          thunkAPI.dispatch(
            setMessage('Topic Preview has been Successfully Created')
          );

          return actualResponse;
        } else {
          await new Promise((resolve) => setTimeout(resolve, 12000));
          return refreshPreviewData();
        }
      };
      return await refreshPreviewData();
    } catch (error) {

      const message =
        (error?.response &&
          error?.response?.data &&
          (error?.response?.data?.detail ||
            error?.response?.data?.detail?.[0]?.msg)) ||
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();

      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const searchPost = createAsyncThunk(
  'search_Post',
  async ({ start_date, end_date, keyword, job_id }, thunkAPI) => {
    try {
      // const body ={  "start_date": startDate,  "end_date": endDate,  "keyword": value }
      // const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));

      const body = {
        start_date: start_date,
        end_date: end_date,
        keyword: keyword,
      };

      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TopicService.search_Post(
        // brandUser?.tenant_id,
        // preview_uuid,
        brandUser?.tenant_id,
        // brandUser?.user_details.user_id,
        job_id,
        body
      );
      return { data };
    } catch (error) {
      const message =
        (error?.response &&
          error?.response?.data &&
          error?.response?.data?.detail?.[0]?.msg) ||
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const searchPostPreview = createAsyncThunk(
  'searchPostPreview',
  async ({ start_date, end_date, keyword, job_id }, thunkAPI) => {
    try {
      // const body ={  "start_date": startDate,  "end_date": endDate,  "keyword": value }
      // const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));

      const body = {
        start_date: start_date,
        end_date: end_date,
        keyword: keyword,
      };

      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TopicService.search_Post_Preview(
        // brandUser?.tenant_id,
        // preview_uuid,
        brandUser?.tenant_id,
        // brandUser?.user_details.user_id,
        job_id,
        body
      );
      return { data };
    } catch (error) {
      const message =
        (error?.response &&
          error?.response?.data &&
          error?.response?.data?.detail?.[0]?.msg) ||
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createTopicSideBar = async (body) => {
  try {
    console.log(body, 'body');
  } catch (error) {
    return error.message;
  }
};

const initialState = {
  topicPreviewData: null,
  topicPreviewDataLoader: false,
  reviewsForTopicData: null,
  activeTopicListData: null,
  status:'idle',
  createdTopicData: [],
  filteredReport: null,
  queryValue: [],
  topicAIPreviewData: [],
  popUpActive: false,
  zindexActive: false,
  searchInstaValue: [],
  isLoadingVal: false,
  searchFbValue: [],
  searchYouTubeValue: [],
  commentsValue: [],
  searchVal: [],
  searchText: '',
  resetFlag: false,
  status_fetchCreatedTopic:'idle',
  filterPayload: {},
};

const topicSlice = createSlice({
  name: 'topicBuilder',
  initialState,
  reducers: {
    
    setZindexActive: (state, action) => {
      state.zindexActive = action.payload;
    },
    setPopUpActive: (state, action) => {
      state.popUpActive = action.payload;
    },
    setFilteredReport: (state, action) => {
      state.filteredReport = null;
    },

    setQueryPromt: (state, action) => {
      state.queryValue = action.payload;
    },
    topicPreviewEmpty: (state, action) => {
      state.topicPreviewData = null;
    },
    topicEmptysearchInstaValue: (state, action) => {
      state.searchInstaValue = [];
    },
    topicEmptyFbValue: (state, action) => {
      state.searchFbValue = [];
    },
    topicEmptyYouTubeValue: (state, action) => {
      state.searchYouTubeValue = [];
    },

    topicEmptyCommentsValue: (state, action) => {
      state.commentsValue = [];
    },
    searchTextFunc: (state, action) => {
      state.searchText = action.payload;
    },
    searchTextEmpty: (state, action) => {
      state.searchText = '';
    },
    resetFlagFunc: (state, action) => {
      state.resetFlag = action.payload;
    },
    setFilterPayload: (state, action) => {
      state.filterPayload = action.payload;
    },
    setFetchStatus: (state, action) => {
      state.status_fetchCreatedTopic = 'idle';
    },
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(topicPreview.pending, (state, action) => {
        state.topicPreviewDataLoader = true;
      })
      .addCase(topicPreview.fulfilled, (state, action) => {
        state.topicPreviewData = action.payload;
        state.topicPreviewDataLoader = false;
      })
      .addCase(topicPreview.rejected, (state, action) => {
        state.topicPreviewData = null;
        state.topicPreviewDataLoader = false;
      })
      .addCase(editTopicPreview.pending, (state) => {
        state.topicPreviewDataLoader = true;
      })
      .addCase(editTopicPreview.fulfilled, (state, action) => {
        state.topicPreviewData = action.payload;
        state.topicPreviewDataLoader = false;
      })
      .addCase(editTopicPreview.rejected, (state) => {
        state.topicPreviewData = null;
        state.topicPreviewDataLoader = false;
      })
      .addCase(getinstaSearchList.pending, (state, action) => {
        state.isLoadingVal = true;
        // state.searchInstaValue = action.payload?.data;
      })
      .addCase(getinstaSearchList.fulfilled, (state, action) => {
        state.isLoadingVal = false;
        state.searchInstaValue = action.payload?.data;
      })
      .addCase(getinstaSearchList.rejected, (state, action) => {
        state.isLoadingVal = false;
        state.searchInstaValue = [];
      })
      .addCase(getCommentsListPreview.pending, (state, action) => {
        // state.searchInstaValue = action.payload?.data;
      })
      .addCase(getCommentsListPreview.fulfilled, (state, action) => {
        state.commentsValue = action.payload?.data?.comments_data;
      })
      .addCase(getCommentsListPreview.rejected, (state, action) => {
        state.commentsValue = [];
      })
      .addCase(getCommentsList.pending, (state, action) => {
        // state.searchInstaValue = action.payload?.data;
      })
      .addCase(getCommentsList.fulfilled, (state, action) => {
        state.commentsValue = action.payload?.data?.comments_data;
      })
      .addCase(getCommentsList.rejected, (state, action) => {
        state.commentsValue = [];
      })
      .addCase(getFbSearchList.pending, (state, action) => {
        state.isLoadingVal = true;
        // state.searchInstaValue = action.payload?.data;
      })
      .addCase(getFbSearchList.fulfilled, (state, action) => {
        state.isLoadingVal = false;
        state.searchFbValue = action.payload?.data;
      })
      .addCase(getFbSearchList.rejected, (state, action) => {
        state.isLoadingVal = false;
        state.searchFbValue = [];
      })

      .addCase(getYouTubeSearchList.pending, (state, action) => {
        state.isLoadingVal = true;
        // state.searchInstaValue = action.payload?.data;
      })
      .addCase(getYouTubeSearchList.fulfilled, (state, action) => {
        state.isLoadingVal = false;
        state.searchYouTubeValue = action.payload?.data;
      })
      .addCase(getYouTubeSearchList.rejected, (state, action) => {
        state.isLoadingVal = false;
        state.searchYouTubeValue = [];
      })
      // .addCase(getinstaSearchList.rejected, (state, action) => {
      //   state.searchInstaValue = [];
      // })

      .addCase(reviewsFilterTopic.fulfilled, (state, action) => {
        state.reviewsForTopicData = action.payload.data.reviews;
      })
      .addCase(reviewsFilterTopic.rejected, (state, action) => {
        state.reviewsForTopicData = action.payload.data.reviews;
      })

      .addCase(searchPostPreview.fulfilled, (state, action) => {
        state.searchVal = action.payload?.data;
      })
      .addCase(searchPostPreview.rejected, (state, action) => {
        state.searchVal = action.payload;
      })
      .addCase(searchPost.fulfilled, (state, action) => {
        state.searchVal = action.payload?.data;
      })
      .addCase(searchPost.rejected, (state, action) => {
        state.searchVal = action.payload;
      })
      .addCase(reviewsFilterTopicPreview.fulfilled, (state, action) => {
        state.reviewsForTopicData = action.payload.data.reviews;
      })
      .addCase(reviewsFilterTopicPreview.rejected, (state, action) => {
        state.reviewsForTopicData = action.payload.data.reviews;
      })
      .addCase(reviewsForTopic.fulfilled, (state, action) => {
        state.reviewsForTopicData = action.payload.data.reviews;
      })
      .addCase(reviewsForTopic.rejected, (state, action) => {
        state.reviewsForTopicData = null;
      })
      
      
      .addCase(renameTitleForTopic.fulfilled, (state, action) => {
        state.reviewsForTopicData = action.payload.data.reviews;
      })
      .addCase(renameTitleForTopic.rejected, (state, action) => {
        state.reviewsForTopicData = null;
      })
      
      .addCase(reviewsForSingleComment.fulfilled, (state, action) => {
        console.log(action.payload,"action.payload");
        
        state.reviewsForTopicData = action.payload.data.reviews;
      })
      .addCase(reviewsForSingleComment.rejected, (state, action) => {
        state.reviewsForTopicData = null;
      })
      .addCase(reviewsForSinglePost.fulfilled, (state, action) => {
        state.reviewsForTopicData = action.payload.data.reviews;
      })
      .addCase(reviewsForSinglePost.rejected, (state, action) => {
        state.reviewsForTopicData = null;
      })
      .addCase(reviewsForDownload.fulfilled, (state, action) => {
        state.reviewsForTopicData = action.payload.data.reviews;
      })
      .addCase(reviewsForDownload.rejected, (state, action) => {
        state.reviewsForTopicData = null;
      })
      .addCase(reviewsForCreatedTopic.fulfilled, (state, action) => {
        state.reviewsForTopicData = action.payload.data.reviews;
      })
      .addCase(reviewsForCreatedTopic.rejected, (state, action) => {
        state.reviewsForTopicData = null;
      })
      
      .addCase(activeTopicList.pending, (state, action) => {
        state.status = 'loading';
        state.activeTopicListData = []
        // state.searchInstaValue = action.payload?.data;
      })
      .addCase(activeTopicList.fulfilled, (state, action) => {
        state.status = 'Done'
        state.activeTopicListData = action.payload.data;
      })
      .addCase(activeTopicList.rejected, (state, action) => {
        state.activeTopicListData = null;
      })
      
      .addCase(fetchCreatedTopic.pending, (state, action) => {
        state.status_fetchCreatedTopic = 'loading';
        state.createdTopicData = []
        // state.searchInstaValue = action.payload?.data;
      })

      .addCase(fetchCreatedTopic.fulfilled, (state, action) => {
        state.status_fetchCreatedTopic = 'succeeded';
        state.createdTopicData = [action.payload.data];
        // state.status = 'succeeded';
      })

      .addCase(fetchCreatedTopic.rejected, (state, action) => {
        state.status_fetchCreatedTopic = 'failed';
        console.log('Please Try Again');
      })
      .addCase(createNewTopic.fulfilled, (state, action) => {
        state.createdTopicData = [action.payload.data];
      })
      .addCase(createNewTopic.rejected, (state, action) => {
        console.log('Please Try Again');
      })
      .addCase(FilterReportBasedOnDates.rejected, (state, action) => {
        state.filteredReport = null;
      })
      .addCase(FilterReportBasedOnDates.fulfilled, (state, action) => {
        state.filteredReport = action.payload.data;
      })
      .addCase(QueryPromptApi.rejected, (state, action) => {
        state.queryValue = null;
      })
      .addCase(QueryPromptApi.fulfilled, (state, action) => {
        state.queryValue = action.payload.response;
      })
      .addCase(topicAIPreview.rejected, (state, action) => {
        state.topicPreviewData = null;
      })
      .addCase(topicAIPreview.fulfilled, (state, action) => {
        state.topicPreviewData = action.payload;
      });
  },
});

export const {
  setZindexActive,
  setPopUpActive,
  setQueryPromt,
  topicPreviewEmpty,
  topicEmptysearchInstaValue,
  topicEmptyFbValue,
  topicEmptyYouTubeValue,
  topicEmptyCommentsValue,
  searchTextFunc,
  searchTextEmpty,
  resetFlagFunc,
  setFilterPayload,
  setFetchStatus
} = topicSlice.actions;

export default topicSlice.reducer;
